import { createContext } from "react";

export const AgentContext = createContext(window.agentDetails);
export const DebugModeContext = createContext([window.debugMode === true, window.umbracoAdminUrl]);
export const PricingDisplayMethodContext = createContext();
export const ErrorContext = createContext();
export const LoadingContext = createContext([]);
